import React, { CSSProperties, ReactNode } from "react";
import FormItemError from "./FormItemError";
import "./FormItem.css";

type FormItemProps = {
  readonly name: string;
  readonly style?: CSSProperties;
  readonly label?: string;
  readonly fieldId: string;
  readonly children: ReactNode;
};

function FormItem({ name, style, fieldId, label, children }: FormItemProps) {
  return (
    <div className="form-item" style={style}>
      {label && <label htmlFor={fieldId}>{label}</label>}
      {children}
      <FormItemError name={name} />
    </div>
  );
}

export type { FormItemProps };
export default FormItem;
